var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BasePaymentForm", {
    staticClass: "custom-payment-form",
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "icon form-group mt-2 mb-1 text-success" },
              [
                _c("i", { staticClass: "fas fa-check-circle mb-2" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("apps.payment.message.paymentsuccess")) +
                      "\n      "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "summary form-group mt-3 mb-0" }, [
              _c("div", { staticClass: "section" }, [
                _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("apps.payment.label.ordernumber")) +
                      ":\n        "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "text-right" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.transaction.chargeId) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section" }, [
                _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("apps.payment.label.paymentmethod")) +
                      ":\n        "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "text-right" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "apps.payment.message.paymentmethod_" +
                            _vm.transaction.paymentMethod
                        )
                      ) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section" }, [
                _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("apps.payment.label.payamount")) +
                      ":\n        "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "text-right" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.getCurrencyWithNumber(
                          _vm.numberel(_vm.transaction.paidAmount, "0,0.[00]")
                        )
                      ) +
                      "\n        "
                  )
                ])
              ])
            ])
          ]
        },
        proxy: true
      },
      {
        key: "footer-actions",
        fn: function() {
          return [
            _c("BaseButton", {
              attrs: {
                text: _vm.$t("button.gotohomepage"),
                className: "btn-web"
              },
              on: { click: _vm.onClickNext }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a79fe8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a79fe8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paymentpackage/Paid.vue
// module id = null
// module chunks = 